/**
 * 商城中用到的特定方法，业务相关
 */

import Cookies from 'js-cookie'
import { getCookie, getQueryString } from './common'
import API from 'api'
import { Dialog } from '@vivo/vos-ui'
import env from './clientEnv'

function setReferrer() {
  const referKey = 'shop_outer_refer'
  let referrer = document.referrer
  let location = window.location.href
  // refer仅仅是shop passport pay时，不覆盖
  let noCoveredCond =
    referrer == '' ||
    !referrer.indexOf('http://shop.vivo.com.cn') ||
    !referrer.indexOf('https://shop.vivo.com.cn') ||
    !referrer.indexOf('http://mshopact.vivo.com.cn') ||
    !referrer.indexOf('https://mshopact.vivo.com.cn') ||
    !referrer.indexOf('http://passport.vivo.com.cn') ||
    !referrer.indexOf('https://passport.vivo.com.cn') ||
    !referrer.indexOf('http://pay.vivo.com.cn') ||
    !referrer.indexOf('https://pay.vivo.com.cn') ||
    !referrer.indexOf('https://www.tenpay.com') ||
    !referrer.indexOf('https://cashier.95516.com') ||
    !referrer.indexOf('https://unitradeprod.alipay.com') ||
    !referrer.indexOf('https://mclient.alipay.com')

  // 当前页面url包含source=vivo_ly,覆盖refer
  let coveredCond = location.indexOf('source=vivo_ly') >= 0

  if (!getCookie(referKey) || !noCoveredCond || coveredCond) {
    var sourceRefer = referrer == '' || coveredCond ? location : referrer
    // 此处url会被转义两次
    // setCookie(referKey, encodeURIComponent(sourceRefer))
    document.cookie = `${referKey} = ${encodeURIComponent(sourceRefer)};path=/;`
  }
}

// 加载js
function loadAsScript(str) {
  const script = document.createElement('script')

  script.innerHTML = str
  document.querySelector('body').appendChild(script)
}

// 加载资源文件
function loadRes(url, type, callback) {
  var dom = document.createElement(type)

  if (type === 'link') {
    dom.setAttribute('rel', 'stylesheet')
    dom.setAttribute('type', 'text/css')
    dom.setAttribute('href', url)
  } else if (type === 'script') {
    dom.type = 'text/javascript'
    dom.src = url
  }
  dom.onload = callback
  document.querySelector('head').appendChild(dom)
}

// 引入官网头尾
function includeHF(params) {
  API.getCommonHF(params).then(res => {
    const cssUrl = /<link.+href="([^"]+)".+>/g.exec(res.cssLink)[1]
    const scriptUrl = /<script.+src="([^"]+)".+>/g.exec(res.scriptLink)[1]
    const $headerBG = document.querySelector('#gw_bg')

    // 重置头部高度
    if ($headerBG && res.wapNavHeight) {
      $headerBG.style.height = res.wapNavHeight
    }

    loadRes(cssUrl, 'link', () => {
      document.querySelector('#gw_header').innerHTML = res.headHtml
      document.querySelector('#gw_footer').innerHTML = res.footHtml

      const headerOptionStr = document.querySelector('#vp-head-header-script').innerHTML
      const footerOptionStr = document.querySelector('#vp-head-footer-script').innerHTML

      try {
        const gwHeader = document.querySelector('#gw_header script')
        if (gwHeader) {
          loadAsScript(gwHeader.innerHTML)
        }
      } catch (e) { }

      loadAsScript(headerOptionStr)
      loadAsScript(footerOptionStr)
      loadRes(scriptUrl, 'script')
    })
  })
}

// 引入顶部下载悬浮条
function includeFW(params) {
  API.getCommonFW(params).then(res => {
    const cssUrl = /<link.+href="([^"]+)".+>/g.exec(res.cssLink)[1]
    const scriptUrl = /<script.+src="([^"]+)".+>/g.exec(res.scriptLink)[1]

    loadRes(cssUrl, 'link', () => {
      if (res.headHtml) {
        document.querySelector('#fw_header').innerHTML = res.headHtml

        try {
          const fwHeader = document.querySelector('#fw_header script')
          if (fwHeader) {
            loadAsScript(fwHeader.innerHTML)
          }
        } catch (e) { }

        loadRes(scriptUrl, 'script')
      }
    })
  })
}

// 确认是否需要实名认证
async function checkRealName(needCallback, needLessCallback) {
  const data = await API.isRealNameRegister()
  let realNameRegister = data.realNameRegister
  if (realNameRegister == null || realNameRegister == 0) {
    Dialog.confirm({
      title: '请实名认证',
      content:
        '根据国家互联网信息办公室的《互联网跟帖评论服务管理规定》，发表内容前需进行实名认证，认证完成后即可发表内容',
      confirmText: '实名认证',
      cancelText: '取消',
      onConfirm: () => {
        needCallback && needCallback(data.passportHost)
      }
    })
  } else {
    needLessCallback && needLessCallback()
  }
}

// 页面跳转处理
async function redirectCommon(redirectUrl, targetUrl) {
  // 非空处理
  if (!redirectUrl) {
    redirectUrl = window.location.href
  }
  // 对重定向url做合法性过滤，必须属于.vivo.com.cn的子域，否则跳转到商城首页
  redirectUrl = formatVivoUrl(redirectUrl)

  window.location.href = targetUrl + encodeURIComponent(redirectUrl)
}

// 检查回跳地址，如果回跳地址不是.vivo.com.cn的子域名，则将回调地址替换为商城首页
function formatVivoUrl(url) {
  let formatUrl = decodeURIComponent(url)

  if (/^(https?:\/\/)?(\w+\.)*vivo\.com\.cn(\?|\/|$)/.test(formatUrl) || formatUrl.indexOf('/') == 0) {
    return url
  } else {
    return 'https://shop.vivo.com.cn/wap/index.html'
  }
}
// 是否需要隐藏头部，包含首页，商详页，个人中心首页，通用头部
function isHidenHeader() {
  // 在官网app，微信，支付宝，农行，vivo系app中隐藏头部,或UA中包含noHeader=true
  const { isVivoRelatedApp, isAlipay, isWx, isBankabc } = env
  return (
    isVivoRelatedApp ||
    isAlipay ||
    isWx ||
    getQueryString('noHeader') === 'true' ||
    /noheader=true/.test(navigator.userAgent.toLowerCase())
  )
}

// 是否全场景隐藏商城头部
function hidenShopHeader() {
  // url优先级最高，若具有showHeader参数，则不进行隐藏
  if (getQueryString('showHeader') === 'true') {
    return false
  }
  // 若UA上存在隐藏头部信息时，则对全场景进行头部隐藏（对智慧生活、v消息进行单独适配）
  if (
    /noheader=true/.test(navigator.userAgent.toLowerCase()) ||
    env.isVHome ||
    env.isvChat ||
    env.isGameCenter ||
    env.isWallet
  ) {
    return true
  }
  return false
}
// 是否允许商详页进行deeplink跳转
function allowShopDeeplink() {
  // url优先级最高，若具有showHeader参数，则不进行隐藏
  if (getQueryString('deeplink') === 'true') {
    return true
  }
  // 若UA上存在关闭deeplink信息时，则不进行deeplink跳转
  if (/shopdeeplink=false/.test(navigator.userAgent.toLowerCase())) {
    return false
  }
  return true
}
/**
 * 更新用户浏览的商品的历史记录
 * @param {Number} spuId
 */
function updateViewHistory(spuId) {
  const HIST = 'shop_view_history'
  let history = Cookies.get(HIST)
  if (history) {
    history = history.split('-')
  } else {
    history = []
  }
  const index = history.indexOf(spuId)
  // 浏览记录是否存在，不存在则进行添加
  if (index < 0) {
    if (history.length <= 20) {
      history.push(spuId)
    } else {
      history.shift()
      history.push(spuId)
    }
  } else {
    // 浏览记录存在，则移动到最后面
    history.splice(index, 1)
    history.push(spuId)
  }
  Cookies.set(HIST, history.join('-'), { domain: document.domain, expires: 365 * 10, path: '/' })
}

export default {
  setReferrer,
  checkRealName,
  redirectCommon,
  formatVivoUrl,
  includeHF,
  includeFW,
  isHidenHeader,
  hidenShopHeader,
  allowShopDeeplink,
  updateViewHistory
}
